"use client"

import dynamic from "next/dynamic"

// 动态导入非首屏必需的组件，优化首屏渲染速度
// 这些组件在页面交互后加载，不影响首屏渲染
const GoogleAnalytics = dynamic(
	() => import("@next/third-parties/google").then((mod) => ({ default: mod.GoogleAnalytics })),
	{
		ssr: false,
	}
)

const CookieConsentCmp = dynamic(() => import("@repo/ui/cookie-consent"), {
	ssr: false,
})

const PageTracker = dynamic(() => import("@repo/ui").then((mod) => ({ default: mod.PageTracker })), {
	ssr: false,
})

/**
 * 延迟加载的非首屏组件容器
 * 这些组件在页面交互后加载，优化首屏性能
 */
export default function DeferredComponents() {
	return (
		<>
			<CookieConsentCmp />
			<PageTracker />
		</>
	)
}

/**
 * Google Analytics 组件
 * 需要在 </body> 之后、</html> 之前渲染
 */
export function DeferredGoogleAnalytics({ gaId }: { gaId: string }) {
	return <GoogleAnalytics gaId={gaId} />
}
